<template>
  <div>
    <section class="officer-open-recruitment-post-create ly-create">
      <div class="section-inner">
        <div class="section-cont">
          <h2>사관 &middot; 공채 공고 관리</h2>
          <p class="site-path">
            <span>Home</span>&nbsp;&gt;&nbsp;
            <span>EDUCATION</span>&nbsp;&gt;&nbsp;
            <span>사관 &middot; 공채 공고 관리</span>
          </p>
          <!-- /.site-path -->
          <table>
            <colgroup>
              <col class="col1" />
              <col class="col2" />
            </colgroup>
            <tr>
              <th scope="row">
                <label for="brand-name">제목</label>
              </th>
              <td>
                <input
                  type="text"   
                  id="brand-name"
                  name="brand-name"
                  v-model="title"
                />
              </td>
            </tr>
            <tr>
              <th scope="row">
                <label for="last-date">마감일</label>
              </th>
              <td>

              <date-picker v-model="due_date" valueType="format" format="YYYY.MM.DD" :lang="lang"></date-picker>

              </td>
            </tr>
            <tr>
              <th scope="row">내용</th>
              <td>
                <ckeditor
                  :editor="editor"
                  v-model="editorData"
                  :config="editorConfig"
                  class="text-area"
                ></ckeditor>
                <!-- <span class="text-area">
                </span> -->
              </td>
            </tr>

            <tr>

              <th scope="row">상세 이미지</th>
              <td class="file-cell">
                <div class="attached-file-wrap">
                  <div
                    class="attached-file"
                    v-for="(file, index) in files"
                    v-bind:key="index"
                  >
                    <p v-if="file">{{ file.name }}</p>
                    <p v-else class="file-empty"></p>
                    <file-select v-model="files[index]" ></file-select>
                  </div>
                </div>

                <span>10MB 이하 업로드 (jpg / png / gif / bmp)</span>
              </td>

            </tr>
            <tr>
              <th scope="row">지원서 양식</th>
              <td class="file-cell">

                <div class="attached-file-wrap">
                  <div
                    class="attached-file"
                    v-for="(file, index) in applicationformFiles"
                    v-bind:key="index"
                  >
                    <p v-if="file">{{ file.name }}</p>
                    <p v-else class="file-empty"></p>
                    <file-select v-model="applicationformFiles[index]" ></file-select>
                  </div>
                </div>

                <!-- <p v-if="applicationform">{{ applicationform.name }}</p>
                <p v-else class="file-empty"></p>
                <file-select v-model="applicationform"></file-select> -->
                <span>50MB 이하 업로드 (pptx / doc / xlsx / hwp / pdf)</span> 

              </td>
            </tr>
            <tr>
              <th scope="row">지원 링크 버튼</th>
              <td>
                <div
                  class="btn-slot"
                  :class="{ 'is-hidden': slot.show_yn === 'N' }"
                  v-for="(slot, index) in buttonSlots"
                  v-bind:key="index"
                >
                  <span class="btn-slot-no">{{ index + 1 }}</span>
                  <input
                    type="text"
                    class="btn-slot-label"
                    v-model="slot.label"
                    :maxlength="BUTTON_LIMITS.LABEL_MAX"
                    placeholder="버튼 문구 (예시: 지원하기)"
                  />
                  <input
                    type="text"
                    class="btn-slot-url"
                    v-model="slot.url"
                    :maxlength="BUTTON_LIMITS.URL_MAX"
                    placeholder="https:// 로 시작하는 링크"
                  />
                  <button class="btn-slot-toggle" @click="onClickToggleSlot(slot)">
                    {{ slot.show_yn === 'N' ? '숨김' : '노출' }}
                  </button>
                  <button
                    class="btn-slot-del"
                    :disabled="!slot.label && !slot.url"
                    @click="onClickRemoveSlot(index)"
                  >
                    삭제
                  </button>
                  <span
                    class="btn-slot-limit"
                    v-if="slot.label.length >= BUTTON_LIMITS.LABEL_MAX"
                    >버튼 문구는 {{ BUTTON_LIMITS.LABEL_MAX }}자까지 입력할 수
                    있습니다.</span
                  >
                </div>
                <span class="btn-slot-guide">
                  최대 5개 등록 (문구와 링크를 모두 입력한 버튼만 노출됩니다.)
                  <em>
                    링크는 http 또는 https 로 시작해야 하며, 새 창으로 열립니다
                  </em>
                  <em>숨김으로 설정한 버튼은 저장되지만 홈페이지에는 보이지 않습니다</em>
                </span>
              </td>
            </tr>
          </table>
          <!-- /.table-->
          <router-link
            :to="{ name: 'OfficerOpenRecruitmentPostList' }"
            class="btn-white"
            tag="a"
            >목록</router-link
          >
          <button class="btn-blue btn-right" @click="onClickCreate">
            저장
          </button>
          <!-- /.btn -->
        </div>
        <app-footer />
      </div>
    </section>
  </div>
</template>

<script>
import AppFooter from "../../AppFooter.vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import FileSelect from "../..//FileSelect.vue";
import DatePicker from 'vue2-datepicker';
import {
  BUTTON_LIMITS,
  emptySlots,
  removeSlot,
  toPayload,
  validateSlots,
} from "../../../config/announce_buttons";
import 'vue2-datepicker/index.css';

export default {
  components: { AppFooter, FileSelect, DatePicker },
  name: "OfficerOpenRecruitmentPostCreate",
  data() {
    return {
      title: '',
      details: '', 

      // applicationform: null ,
      applicationformFiles: [null, null, null, null, null], 

      files: [null, null, null, null, null] ,
      
      editor: ClassicEditor,
      editorData: "",
      editorConfig: {
        // The configuration of the editor.
        toolbar: [],
      },

      // dropdown_due_date: '',
      // minDate: null ,
      due_date: null,
      lang: null, 

      BUTTON_LIMITS,
      buttonSlots: emptySlots(),
    };
  },
  created() {
    this.lang = this.datepicker_lang;
  },
  methods: {
    onClickToggleSlot(slot) {
      slot.show_yn = slot.show_yn === 'N' ? 'Y' : 'N';
    },
    onClickRemoveSlot(index) {
      removeSlot(this.buttonSlots, index);
    },
    onClickCreate() {

      if( this.title == null || this.title.trim().length == 0 ) {
        return this.$fire({
          title: "제목을 입력해주세요.",
          text: "",
          type: "warning",
          timer: 2000
        }).then(r => {
          console.log(r.value);
        });
      }

      if( this.due_date == null ) {
        return this.$fire({
          title: "마감일을 선택해주세요",
          text: "",
          type: "warning",
          timer: 2000
        }).then(r => {
          console.log(r.value);
        });
      }

      if( this.editorData.length == 0 ) {
        return this.$fire({
          title: "내용을 입력해주세요.",
          text: "",
          type: "warning",
          timer: 2000
        }).then(r => {
          console.log(r.value);
        });

      }

      console.log("in onClickCreate ==>  name ", this.title );
      console.log("in onClickCreate ==>  due_date ", this.due_date );
      console.log("in onClickCreate ==>  details ", this.editorData );


      const buttonErrors = validateSlots(this.buttonSlots);
      if (buttonErrors.length > 0) {
        return this.$fire({
          title: buttonErrors[0],
          text: "",
          type: "warning",
          timer: 3000
        });
      }

      let formData = new FormData();
      formData.append("title", this.title );
      formData.append("due_date", this.due_date );
      formData.append("details", this.editorData );
      formData.append("buttons", JSON.stringify( toPayload(this.buttonSlots) ) );

      var count = 0 ; 
      for (let attfile of this.files) {
        if( attfile != null && attfile != undefined ) {
          var fieldname = "files[" + count +"]"; 
          formData.append(fieldname, attfile );
        }
        count++;
      }

      // if( this.applicationform != null ) formData.append("applicationform", this.applicationform);
      count = 0 ; 
      for (let attachfile of this.applicationformFiles) {
        if( attachfile != null && attachfile != undefined ) {
          var applicationformFieldName = "applicationform[" + count +"]"; 
          formData.append(applicationformFieldName, attachfile );
        }
        count++;
      }


      this.$store.dispatch("education/req_create_officeropenrecruitment_announce", formData  ).then( result => {
        console.log( 'req_create_officeropenrecruitment_announce result => ', result );
        this.$alert("등록하였습니다.").then(() => {
          this.$router.push({ name: "OfficerOpenRecruitmentPostList" });
        });
      }).catch( err => {
        console.log( ' error => ', err );
        if( err.response && err.response.status === 400 && err.response.data && err.response.data.message ) {
          this.$fire({
            title: err.response.data.message,
            text: "",
            type: "warning",
            timer: 3000
          });
        }
      });


    },


  },
};
</script>

<style scoped>
.btn-slot {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
}

.btn-slot-limit {
  width: 100%;
  margin-top: -4px;
  padding-left: 60px;
  font-size: 14px;
  color: #777;
}

/* 폼 공통 input[type="text"] 의 width:100% 보다 flex-basis 가 우선한다 */
.btn-slot-label {
  flex: 0 0 260px;
}

.btn-slot-url {
  flex: 1;
  min-width: 0;
}

.btn-slot-toggle,
.btn-slot-del {
  flex-shrink: 0;
  width: 70px;
  height: 50px;
  border: 1px solid #ccc;
  color: #777;
}

.btn-slot-toggle {
  border-color: #0056aa;
  color: #0056aa;
}

.btn-slot-del:disabled {
  cursor: default;
  opacity: 0.4;
}

.btn-slot.is-hidden input {
  background-color: #f2f2f2;
  color: #aaa;
}

.btn-slot.is-hidden .btn-slot-toggle {
  border-color: #ccc;
  color: #aaa;
}

.btn-slot-no {
  flex-shrink: 0;
  width: 50px;
  height: 50px;
  line-height: 48px;
  text-align: center;
  font-weight: 500;
  color: #222;
  background-color: #edeff5;
  border: 1px solid #ccc;
}

.btn-slot-guide {
  display: block;
  margin-top: 4px;
  font-size: 16px;
}

.btn-slot-guide em {
  display: block;
}
</style>
